export default "__VITE_ASSET__CKlkke6F__"